import { Box, Typography } from "@mui/material";
import Head from "next/head";
import { useEffect } from "react";
import Breadcrumbs from "../../../src/components/common/Breadcrumbs";
import LoanFormPopupV2 from "../../../src/Drawer/LoanFormPopupV2";
import { MemoizedConnectDrawer } from "../../../src/Drawer/connectDrawer";
import FAQ from "../../../src/SDK/FAQ/faq";
import { OEMAdv } from "../../../src/constants/VehicleAdvantages";
import { oemVehicleContentData } from "../../../src/constants/VehiclesContent";
import { brandFAQs } from "../../../src/constants/brandFaqs";
import { blogData } from "../../../src/constants/oemBlogData";
import { oemPriceList } from "../../../src/constants/oemPriceInfo";
import { oemPromiseList } from "../../../src/constants/oemPromises";
import { convertFAQsToQuestions, generateFAQPageSchema } from "../../../src/utils/FAQPageSchemaGenerator.js";
import { primary } from "../../../src/constants/theme";
import {
  BrandLogos,
  newVehicles,
  vehicles,
} from "../../../src/constants/vehicleData";
import { imagesWEBP } from "../../../src/constants/webpImages";
import { MemoizedFooter } from "../../../src/layouts/footer";
import { MemoizedHeader } from "../../../src/layouts/header";
import WhatsAppFloater from "../../../src/modules/Brand/WhatAppFloater";
import BookEVConsultationForm from "../../../src/modules/Home/BookEVconsult/bookEVConsultation";
import FullscreenDrawer from "../../../src/modules/Home/HomePageRevamp/VehicleSlideDrawer";
import QlDrawerComponent from "../../../src/modules/LeadDataCollection/DrawerComponents/LoanDrawerComponents";
import MemoizedTopBanner from "../../../src/modules/Vehicles/Banner/BannerGeneric";
import BrandLogoTile from "../../../src/modules/Vehicles/Banner/BrandLogoTile";
import BulletPoints from "../../../src/modules/Vehicles/Banner/BulletPoints";
import HeaderDesc from "../../../src/modules/Vehicles/Banner/HeaderDesc";
import VehiclesAdv from "../../../src/modules/Vehicles/Banner/VehiclesAdv";
import MemoizedBrandBlogList from "../../../src/modules/Vehicles/BrandBlogList";
import MemoizedBrandDealerNear from "../../../src/modules/Vehicles/BrandDealerNear";
import MemoizedBrandPromises from "../../../src/modules/Vehicles/BrandPromises";
import MemoizedBrandVehicleLoan from "../../../src/modules/Vehicles/BrandVehicleLoan";
import MemoizedBrandVehicleVariant from "../../../src/modules/Vehicles/BrandVehicleVariant";
import { MemoizedBrandVehiclesListing } from "../../../src/modules/Vehicles/BrandVehicleslisting";
import MemoizedVehiclePriceList from "../../../src/modules/Vehicles/TableData/VehiclePriceList";
import MemoizedSearchHeader from "../../../src/modules/Vehicles/searchHeader";
import AtfContentSectionBrand from "../../../src/components/common/ContentTemplates/AtfContentSectionBrand";
import SeoContentSection from "../../../src/components/common/ContentTemplates/SeoContentSection";
import SeoContentRenderer from "../../../src/components/common/ContentTemplates/SeoContentRenderer";
import { sendAnalytics } from "../../../src/utils/analyticsCommon";
import {
  META_TITLE,
  META_CONTENT,
  TOP_BANNER_HEADER,
  BOOK_EV_CONSULTATION_FORM_HEADER,
  BOOK_EV_CONSULTATION_CTA_TEXT,
  VEHICLE_LISTING_HEADER_INFO,
  VEHICLE_LISTING_DESCRIPTION,
  EV_PRICES_HEADER,
  EV_PRICES_DESCRIPTION,
  PROMISE_HEADER_INFO,
  ADVANTAGES_OF_3_WHEELER_HEADER_INFO,
  ADVANTAGES_OF_3_WHEELER_CONTENT,
  VEHICLE_LOAN_HEADER_INFO,
  BLOG_HEADER,
  VEHICLE_VARIENT_HEADER_INFO,
  VEHICLE_VARIANT_DESCRIPTION,
  EULAR_MAP_LOCATION_HEADER,
  EULAR_MAP_LOCATION_DESCRIPTION,
  AVAILABLE_BRANDS_HEADER,
  PROMISE_SUB_HEADER_TEXT,
  GAURANTEED_LOAN_EMI_CARD_DATA
} from "../../../src/constants/electricCommericalVehicle/Eular/Eular";
import {
  TITLE,
  META_CONTENT as NEW_META_CONTENT,
  VEHICLE_LINK,
  H1_HEADING,
  CTA_TEXT,
  FAQ_HEADING,
  CONNECT_HEADING,
  CONNECT_SUBHEADING,
  CONNECT_CTA_TEXT,
  BREADCRUMB_ITEMS,
  BREADCRUMB_SCHEMA,
  ATF_CONTENT,
  ATF_NOTE,
  ATF_TABLE_HEADING,
  ATF_TABLE_COLUMNS,
  ATF_TABLE_DATA,
  SEO_FOOTER_CONTENT,
} from "../../../src/constants/electricCommericalVehicle/Eular/index.js";
import {
  WHY_TURNO_HEADER,
  WHY_TURNO_SUB_TEXT,
  WHY_TURNO_DATA,
} from "../../../src/constants/PassengerLandingPageContants/electricPassenger";
import { renderWhyTurnoContent } from "../../../src/modules/Unigage/whyTurno";
import { useMobile } from "../../../src/utils/findViewport";
import { generateBrandCollectionPageSchema } from "../../../src/utils/CollectionPageSchema.js";
import { generateItemListSchema, createListItem } from "../../../src/utils/ItemListSchema.js";

export default function VehicleBrand({ brand, BrandVehiclesData, BrandLogos, collectionPageSchema, itemListSchema, faqPageSchema }) {
  const isMobile = useMobile();

  useEffect(() => {
    sendAnalytics(
      "screen_viewed",
      { screen_name: `electric_commercial_vehicle_${brand}` },
      "en"
    );
  }, [brand]);

  //We need to add SEO Meta info later

  const renderTopBanner = () => {
    return (
      <div className="topBannerContainer">
        {/* <h2
          style={{
            textAlign: isMobile ? "center" : "",
            margin: isMobile ? "" : "10px 8%",
            fontSize:isMobile ? "20px" : "24px",
            marginBottom: "12px",
            padding: isMobile ? "0px 52px" : "",
          }}
        >
          {TOP_BANNER_HEADER}
        </h2> */}
        <MemoizedTopBanner
          bannerData={{
            desktopImg: imagesWEBP?.Euler?.eulerDesktopBanner,
            mobileImg: imagesWEBP?.eulerBanner,
            alt: "Euler electric auto banner",
          }}
        />
      </div>
    );
  };

  const renderBookEvConsultationForm = () => {
    return (
      <div className="bookEvConsultationFormContainer">
        <Box sx={{ display: { sm: "block", md: "none", lg: "none" } }}>
          <h2 style={{ textAlign: "center", fontSize: "20px", fontWeight:"550", padding: "0px 16px", margin: "0px 0px 10px 0px" }}>
            {BOOK_EV_CONSULTATION_FORM_HEADER}
          </h2>

          <BookEVConsultationForm ctaText={BOOK_EV_CONSULTATION_CTA_TEXT} />
        </Box>
      </div>
    );
  };

  return (
    <>
      <Head>
        <title>{TITLE}</title>
        {NEW_META_CONTENT.map((meta, index) => (
          <meta
            key={index}
            {...(meta.name ? { name: meta.name } : { property: meta.property })}
            content={meta.content}
          />
        ))}
        <link rel="canonical" href={VEHICLE_LINK} />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(collectionPageSchema),
          }}
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(itemListSchema),
          }}
        />
        <script
          type="application/ld+json"
          defer
          dangerouslySetInnerHTML={{ __html: JSON.stringify(faqPageSchema) }}
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(BREADCRUMB_SCHEMA),
          }}
          defer
        />
      </Head>

      <body>
        <Box>
          {/* Main component */}
          <Box sx={{ display: { xs: "none", md: "block" } }}>
            <MemoizedHeader />
          </Box>
          <FullscreenDrawer />
          <LoanFormPopupV2 />
          <QlDrawerComponent />
          <Box sx={{ display: { xs: "block", md: "none" } }}>
            <MemoizedSearchHeader isProductPage={true} />
          </Box>
          {renderTopBanner()}
          {renderBookEvConsultationForm()}

          <Typography
            variant="h1"
            style={{ fontSize: "34px", fontWeight: 700, paddingLeft: "8%" }}
          >
            {H1_HEADING}
          </Typography>

          <AtfContentSectionBrand
            content={ATF_CONTENT}
            tableData={{
              type: "pricing",
              heading: ATF_TABLE_HEADING,
              columns: ATF_TABLE_COLUMNS,
              data: ATF_TABLE_DATA,
            }}
            note={ATF_NOTE}
          />

          <MemoizedBrandVehiclesListing
            vehicleLocalData={BrandVehiclesData}
            ctaText={CTA_TEXT}
          />
          {isMobile &&
            renderWhyTurnoContent(
              WHY_TURNO_HEADER,
              WHY_TURNO_SUB_TEXT,
              WHY_TURNO_DATA
            )}
          {/* <MemoizedVehiclePriceList
            priceData={{
              priceList: oemPriceList?.euler,
              headerInfo: EV_PRICES_HEADER,
              description: EV_PRICES_DESCRIPTION,
            }}
          /> */}
          <MemoizedBrandPromises
            promisesData={{
              headerInfo: PROMISE_HEADER_INFO,
              promiseList: oemPromiseList?.euler,
              subHeaderText: PROMISE_SUB_HEADER_TEXT,
            }}
          />

          <BrandLogoTile
            BrandLogos={BrandLogos}
            brand={brand}
            title={AVAILABLE_BRANDS_HEADER}
          />

          <HeaderDesc
            HeadingTag="h2"
            heading={ADVANTAGES_OF_3_WHEELER_HEADER_INFO}
            subText={ADVANTAGES_OF_3_WHEELER_CONTENT}
          />
          <MemoizedBrandPromises
            promisesData={{
              headerInfo: "",
              promiseList: OEMAdv?.euler,
              subHeaderText: "",
            }}
          />
          <MemoizedBrandVehicleLoan
            headerInfo={VEHICLE_LOAN_HEADER_INFO}
            cardDetails={GAURANTEED_LOAN_EMI_CARD_DATA}
          />

          <MemoizedBrandBlogList
            blogData={{
              data: blogData?.euler,
              headerInfo: BLOG_HEADER,
            }}
          />
          <MemoizedBrandVehicleVariant
            brandVariantData={{
              headerInfo: VEHICLE_VARIENT_HEADER_INFO,
              description: VEHICLE_VARIANT_DESCRIPTION,
              variantList: oemPriceList?.euler,
            }}
          />

          <MemoizedBrandDealerNear
            BannerDealerData={{
              headerInfo: EULAR_MAP_LOCATION_HEADER,
              description: EULAR_MAP_LOCATION_DESCRIPTION,
              desktopImg: imagesWEBP?.locationBanner,
              mobileImg: imagesWEBP?.locationBanner,
              alt: "Euler electric auto",
            }}
          />

          <SeoContentSection>
            <SeoContentRenderer content={SEO_FOOTER_CONTENT} />
          </SeoContentSection>

          <Box
            style={{
              justifyContent: "center",
              marginTop: "30px",
              paddingTop: "20px",
              padding: "20px 8% 20px 8%",
              width: "100% !important",
              background: primary?.lightGrey,
            }}
          >
            <FAQ
              faqList={brandFAQs?.euler}
              showItems={brandFAQs?.euler?.length}
              headText={FAQ_HEADING}
            />
          </Box>
          <WhatsAppFloater />
          <MemoizedConnectDrawer
            heading={CONNECT_HEADING}
            subHeading={CONNECT_SUBHEADING}
            ctaText={CONNECT_CTA_TEXT}
          />
          <Box sx={{ width: { xs: "100%", md: "84%" }, margin: "20px auto", padding: { xs: "0 12px", md: "0" } }}>
            <Breadcrumbs items={BREADCRUMB_ITEMS} />
          </Box>

          <MemoizedFooter />
        </Box>
      </body>
    </>
  );
}

export const getStaticProps = (context) => {
  const brand = "Euler";
  let allvehicles = [...vehicles, ...newVehicles];
  let BrandVehiclesData = allvehicles?.filter((vehicle) => {
    return vehicle?.brand?.toLocaleLowerCase() === brand?.toLocaleLowerCase();
  });

  // Generate CollectionPage Schema
  const collectionPageSchema = generateBrandCollectionPageSchema({
    title: TITLE,
    url: VEHICLE_LINK,
    description: NEW_META_CONTENT[0]?.content,
    headline: H1_HEADING,
    keywords: NEW_META_CONTENT[1]?.content || `${brand} electric vehicles`,
    breadcrumbSchema: BREADCRUMB_SCHEMA,
    primaryImageUrl: imagesWEBP?.Euler?.eulerDesktopBanner,
    brandName: brand,
    datePublished: new Date().toISOString(),
    dateModified: new Date().toISOString(),
  });

  // Generate ItemList Schema
  const itemListSchema = generateItemListSchema({
    name: `${brand} Electric Vehicles`,
    description: `List of ${brand} electric commercial vehicles available at Turno`,
    itemListElement: BrandVehiclesData.map((vehicle, index) => {
      const vehicleUrl = vehicle.vehicle_path_id 
        ? `https://www.turno.club/electric-commercial-vehicles/${brand}/${vehicle.vehicle_path_id}`
        : `https://www.turno.club/electric-commercial-vehicles/${brand}`;
      
      return createListItem({
        position: index + 1,
        name: vehicle.name || vehicle.vehicle_name || `${brand} ${vehicle.vehicle_path_id}`,
        url: vehicleUrl,
        description: vehicle.meta_description || vehicle.page_title || `${brand} ${vehicle.vehicle_name || vehicle.vehicle_path_id} electric vehicle`,
        image: vehicle.image || vehicle.storeImage || vehicle.homeImage,
      });
    }),
    itemListOrder: "Ascending",
    numberOfItems: BrandVehiclesData.length,
    url: VEHICLE_LINK,
  });

  // Generate FAQPage Schema from brandFAQs.euler
  const faqQuestions = convertFAQsToQuestions(brandFAQs?.euler || [], {
    url: VEHICLE_LINK,
    dateCreated: new Date().toISOString(),
    author: {
      "@type": "Organization",
      name: "Turno",
      url: "https://www.turno.club/",
    },
  });

  const faqPageSchema = generateFAQPageSchema({
    mainEntity: faqQuestions,
    name: FAQ_HEADING || "FAQs on Euler Electric Vehicles",
    description: `Frequently asked questions about Euler electric commercial vehicles.`,
    url: VEHICLE_LINK,
    headline: FAQ_HEADING || "FAQs on Euler Electric Vehicles",
    keywords: NEW_META_CONTENT[0]?.content || "Euler, FAQ, electric commercial vehicle",
    inLanguage: "en",
    publisher: {
      "@type": "Organization",
      name: "Turno",
      url: "https://www.turno.club/",
      logo: {
        "@type": "ImageObject",
        url: "https://www.turno.club/logoIcon.png",
      },
    },
    datePublished: new Date().toISOString(),
    dateModified: new Date().toISOString(),
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": VEHICLE_LINK,
    },
    breadcrumb: BREADCRUMB_SCHEMA,
    primaryImageOfPage: {
      "@type": "ImageObject",
      url: imagesWEBP?.Euler?.eulerDesktopBanner || "https://www.turno.club/logoIcon.png",
    },
    isFamilyFriendly: true,
    isAccessibleForFree: true,
  });

  return {
    props: { 
      brand, 
      BrandVehiclesData, 
      BrandLogos,
      collectionPageSchema,
      itemListSchema,
      faqPageSchema,
    },
  };
};
